"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@chakra-ui/react");

function r(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var n = r(e),
    _a = function a() {
  return (_a = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var a in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }).apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function o(e, t) {
  var r = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) {
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    }
  }

  return r;
}

function i(e, t) {
  var r = "function" == typeof Symbol && e[Symbol.iterator];
  if (!r) return e;
  var n,
      a,
      o = r.call(e),
      i = [];

  try {
    for (; (void 0 === t || t-- > 0) && !(n = o.next()).done;) {
      i.push(n.value);
    }
  } catch (e) {
    a = {
      error: e
    };
  } finally {
    try {
      n && !n.done && (r = o.return) && r.call(o);
    } finally {
      if (a) throw a.error;
    }
  }

  return i;
}

function u() {
  for (var e = [], t = 0; t < arguments.length; t++) {
    e = e.concat(i(arguments[t]));
  }

  return e;
}

var s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    c = /^\[object .+?Constructor\]$/,
    l = "object" == typeof s && s && s.Object === Object && s,
    f = "object" == typeof self && self && self.Object === Object && self,
    p = l || f || Function("return this")();

function h(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);

    case 1:
      return e.call(t, r[0]);

    case 2:
      return e.call(t, r[0], r[1]);

    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }

  return e.apply(t, r);
}

function d(e, t) {
  return !!(e ? e.length : 0) && function (e, t, r) {
    if (t != t) return function (e, t, r, n) {
      var a = e.length,
          o = r + (n ? 1 : -1);

      for (; n ? o-- : ++o < a;) {
        if (t(e[o], o, e)) return o;
      }

      return -1;
    }(e, y, r);
    var n = r - 1,
        a = e.length;

    for (; ++n < a;) {
      if (e[n] === t) return n;
    }

    return -1;
  }(e, t, 0) > -1;
}

function g(e, t, r) {
  for (var n = -1, a = e ? e.length : 0; ++n < a;) {
    if (r(t, e[n])) return !0;
  }

  return !1;
}

function v(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n;) {
    e[a + r] = t[r];
  }

  return e;
}

function y(e) {
  return e != e;
}

function m(e, t) {
  return e.has(t);
}

function _(e) {
  var t = -1,
      r = Array(e.size);
  return e.forEach(function (e) {
    r[++t] = e;
  }), r;
}

var b,
    P = Array.prototype,
    S = Function.prototype,
    w = Object.prototype,
    I = p["__core-js_shared__"],
    x = (b = /[^.]+$/.exec(I && I.keys && I.keys.IE_PROTO || "")) ? "Symbol(src)_1." + b : "",
    L = S.toString,
    E = w.hasOwnProperty,
    C = w.toString,
    j = RegExp("^" + L.call(E).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    k = p.Symbol,
    O = w.propertyIsEnumerable,
    D = P.splice,
    M = k ? k.isConcatSpreadable : void 0,
    Q = Math.max,
    R = H(p, "Map"),
    A = H(p, "Set"),
    B = H(Object, "create");

function F(e) {
  var t = -1,
      r = e ? e.length : 0;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

function $(e) {
  var t = -1,
      r = e ? e.length : 0;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

function z(e) {
  var t = -1,
      r = e ? e.length : 0;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

function N(e) {
  var t = -1,
      r = e ? e.length : 0;

  for (this.__data__ = new z(); ++t < r;) {
    this.add(e[t]);
  }
}

function W(e, t) {
  for (var r, n, a = e.length; a--;) {
    if ((r = e[a][0]) === (n = t) || r != r && n != n) return a;
  }

  return -1;
}

function G(e, t, r, n, a) {
  var o = -1,
      i = e.length;

  for (r || (r = K), a || (a = []); ++o < i;) {
    var u = e[o];
    t > 0 && r(u) ? t > 1 ? G(u, t - 1, r, n, a) : v(a, u) : n || (a[a.length] = u);
  }

  return a;
}

function T(e) {
  return !(!re(e) || (t = e, x && x in t)) && (te(e) || function (e) {
    var t = !1;
    if (null != e && "function" != typeof e.toString) try {
      t = !!(e + "");
    } catch (e) {}
    return t;
  }(e) ? j : c).test(function (e) {
    if (null != e) {
      try {
        return L.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }(e));
  var t;
}

F.prototype.clear = function () {
  this.__data__ = B ? B(null) : {};
}, F.prototype.delete = function (e) {
  return this.has(e) && delete this.__data__[e];
}, F.prototype.get = function (e) {
  var t = this.__data__;

  if (B) {
    var r = t[e];
    return "__lodash_hash_undefined__" === r ? void 0 : r;
  }

  return E.call(t, e) ? t[e] : void 0;
}, F.prototype.has = function (e) {
  var t = this.__data__;
  return B ? void 0 !== t[e] : E.call(t, e);
}, F.prototype.set = function (e, t) {
  return this.__data__[e] = B && void 0 === t ? "__lodash_hash_undefined__" : t, this;
}, $.prototype.clear = function () {
  this.__data__ = [];
}, $.prototype.delete = function (e) {
  var t = this.__data__,
      r = W(t, e);
  return !(r < 0) && (r == t.length - 1 ? t.pop() : D.call(t, r, 1), !0);
}, $.prototype.get = function (e) {
  var t = this.__data__,
      r = W(t, e);
  return r < 0 ? void 0 : t[r][1];
}, $.prototype.has = function (e) {
  return W(this.__data__, e) > -1;
}, $.prototype.set = function (e, t) {
  var r = this.__data__,
      n = W(r, e);
  return n < 0 ? r.push([e, t]) : r[n][1] = t, this;
}, z.prototype.clear = function () {
  this.__data__ = {
    hash: new F(),
    map: new (R || $)(),
    string: new F()
  };
}, z.prototype.delete = function (e) {
  return J(this, e).delete(e);
}, z.prototype.get = function (e) {
  return J(this, e).get(e);
}, z.prototype.has = function (e) {
  return J(this, e).has(e);
}, z.prototype.set = function (e, t) {
  return J(this, e).set(e, t), this;
}, N.prototype.add = N.prototype.push = function (e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, N.prototype.has = function (e) {
  return this.__data__.has(e);
};
var q = A && 1 / _(new A([, -0]))[1] == 1 / 0 ? function (e) {
  return new A(e);
} : function () {};

function J(e, t) {
  var r,
      n,
      a = e.__data__;
  return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
}

function H(e, t) {
  var r = function (e, t) {
    return null == e ? void 0 : e[t];
  }(e, t);

  return T(r) ? r : void 0;
}

function K(e) {
  return Y(e) || function (e) {
    return ee(e) && E.call(e, "callee") && (!O.call(e, "callee") || "[object Arguments]" == C.call(e));
  }(e) || !!(M && e && e[M]);
}

var U,
    V,
    X = (U = function U(e) {
  return function (e, t, r) {
    var n = -1,
        a = d,
        o = e.length,
        i = !0,
        u = [],
        s = u;
    if (r) i = !1, a = g;else if (o >= 200) {
      var c = t ? null : q(e);
      if (c) return _(c);
      i = !1, a = m, s = new N();
    } else s = t ? [] : u;

    e: for (; ++n < o;) {
      var l = e[n],
          f = t ? t(l) : l;

      if (l = r || 0 !== l ? l : 0, i && f == f) {
        for (var p = s.length; p--;) {
          if (s[p] === f) continue e;
        }

        t && s.push(f), u.push(l);
      } else a(s, f, r) || (s !== u && s.push(f), u.push(l));
    }

    return u;
  }(G(e, 1, ee, !0));
}, V = Q(void 0 === V ? U.length - 1 : V, 0), function () {
  for (var e = arguments, t = -1, r = Q(e.length - V, 0), n = Array(r); ++t < r;) {
    n[t] = e[V + t];
  }

  t = -1;

  for (var a = Array(V + 1); ++t < V;) {
    a[t] = e[t];
  }

  return a[V] = n, h(U, this, a);
});
var Y = Array.isArray;

function Z(e) {
  return null != e && function (e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  }(e.length) && !te(e);
}

function ee(e) {
  return function (e) {
    return !!e && "object" == typeof e;
  }(e) && Z(e);
}

function te(e) {
  var t = re(e) ? C.call(e) : "";
  return "[object Function]" == t || "[object GeneratorFunction]" == t;
}

function re(e) {
  var t = typeof e;
  return !!e && ("object" == t || "function" == t);
}

var ne = X,
    ae = {
  pagesQuantity: void 0,
  currentPage: 1,
  normalStyles: {},
  separatorStyles: {},
  activeStyles: {},
  isDisabled: !1,
  innerLimit: 0,
  separatorIcon: void 0,
  outerLimit: 0,
  hoverIconLeft: void 0,
  hoverIconRight: void 0
},
    oe = 0,
    ie = -1,
    ue = function ue(e) {
  return e[0];
},
    se = function se(e) {
  return e.slice(-1)[0];
},
    ce = function ce(e) {
  var t = e.pagesQuantity,
      r = e.currentPage,
      n = e.innerLimit,
      a = e.outerLimit;
  if (!t) return [];
  var o = u(Array(t).keys()).map(function (e) {
    return e + 1;
  });
  if (!n || !a) return o;
  var i,
      s,
      c = o.slice(0, a),
      l = o.slice(1).slice(-a),
      f = se(c),
      p = ue(l),
      h = (i = r - n) < f ? o.slice(f, r - 1) : o.slice(i - 1, r - 1),
      d = ne(u(c), u(h)),
      g = ue(h) > f + 1,
      v = (s = r + n) > p ? o.slice(r + 1, p) : o.slice(r, s),
      y = ne(u(v), u(l)),
      m = se(v) < p - 1;
  return function (e) {
    return e.reduce(function (e, t) {
      return u(e, t === f && g ? [f, oe] : t === p && m ? [ie, p] : [t]);
    }, []);
  }(ne(u(d), [r], u(y)));
},
    le = e.createContext({
  state: {
    currentPage: ae.currentPage,
    activeStyles: ae.activeStyles,
    normalStyles: ae.normalStyles,
    separatorStyles: ae.separatorStyles,
    hoverIconRight: ae.hoverIconRight,
    hoverIconLeft: ae.hoverIconLeft,
    innerLimit: ae.innerLimit,
    outerLimit: ae.outerLimit,
    pagesQuantity: ae.pagesQuantity,
    separatorIcon: ae.separatorIcon,
    isDisabled: ae.isDisabled
  },
  actions: {
    setCurrentPage: function setCurrentPage() {
      return null;
    },
    setIsDisabled: function setIsDisabled() {
      return null;
    },
    changePage: function changePage() {
      return null;
    }
  }
}),
    fe = function fe(t) {
  var r = t.children,
      a = t.pagesQuantity,
      o = t.currentPage,
      u = t.innerLimit,
      s = t.outerLimit,
      c = t.separatorStyles,
      l = t.normalStyles,
      f = t.activeStyles,
      p = t.separatorIcon,
      h = t.hoverIconRight,
      d = t.hoverIconLeft,
      g = t.onPageChange,
      v = t.isDisabled,
      y = i(e.useState(ae.currentPage), 2),
      m = y[0],
      _ = y[1],
      b = i(e.useState(ae.isDisabled), 2),
      P = b[0],
      S = b[1],
      w = e.useMemo(function () {
    return f;
  }, [f]),
      I = e.useMemo(function () {
    return c;
  }, [c]),
      x = e.useMemo(function () {
    return u;
  }, [u]),
      L = e.useMemo(function () {
    return a;
  }, [a]),
      E = e.useMemo(function () {
    return s;
  }, [s]),
      C = e.useMemo(function () {
    return l;
  }, [l]),
      j = e.useMemo(function () {
    return p;
  }, [p]),
      k = e.useMemo(function () {
    return d;
  }, [d]),
      O = e.useMemo(function () {
    return h;
  }, [h]);
  e.useEffect(function () {
    S(v);
  }, [v]), e.useEffect(function () {
    var e;
    (e = o) - Math.floor(e) == 0 ? L && (o > L ? console.error("Chakra paginator -> passed down currentPage can't be higher than pagesQuantity") : o < 1 ? console.error("Chakra paginator -> passed down currentPage can't be lower than 1") : o && o !== m && _(o)) : console.error("Chakra paginator -> passed down currentPage has to be a whole number");
  }, [o]);
  var D = {
    hoverIconLeft: k,
    hoverIconRight: O,
    currentPage: m,
    pagesQuantity: L,
    separatorIcon: j,
    normalStyles: C,
    activeStyles: w,
    isDisabled: P,
    innerLimit: x,
    separatorStyles: I,
    outerLimit: E
  },
      M = {
    setCurrentPage: _,
    setIsDisabled: S,
    changePage: function changePage(e) {
      _(e), g(e);
    }
  };
  return n.default.createElement(le.Provider, {
    value: {
      state: D,
      actions: M
    }
  }, r);
},
    pe = function pe(e) {
  var t = o(e, []);
  return n.default.createElement("svg", _a({
    className: "feather feather-chevron-left",
    fill: "none",
    height: "24",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), n.default.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
},
    he = function he(e) {
  var t = o(e, []);
  return n.default.createElement("svg", _a({
    className: "feather feather-chevron-right",
    fill: "none",
    height: "24",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), n.default.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
},
    de = function de(e) {
  var t = o(e, []);
  return n.default.createElement("svg", _a({
    fill: "none",
    height: "24",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), n.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), n.default.createElement("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }), n.default.createElement("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  }));
},
    ge = function ge(r) {
  var o = r.hoverIcon,
      i = r.isDisabled,
      u = r.separatorIcon,
      s = r.separatorStyles,
      c = r.separatorPosition,
      l = e.useContext(le),
      f = l.actions,
      p = l.state,
      h = p.innerLimit,
      d = p.currentPage,
      g = f.setCurrentPage,
      v = e.useMemo(function () {
    return "left" === c ? d - h : "right" === c ? d + h : void 0;
  }, [c, h, d]),
      y = "left" === c ? "backwards" : "forward",
      m = e.useCallback(function () {
    i || v && g(v);
  }, [v, i, g]);
  return n.default.createElement(t.Flex, {
    as: "li"
  }, n.default.createElement(t.Button, _a({
    align: "center",
    "aria-label": "Jump pages " + y,
    bg: "transparent",
    cursor: "pointer",
    justify: "center",
    minW: "auto",
    onClick: m,
    pointerEvents: i ? "none" : "auto",
    pos: "relative",
    px: 1,
    sx: {
      _hover: {
        ".call-to-action": {
          opacity: 1
        }
      }
    }
  }, i ? {
    "aria-disabled": !0
  } : {}, s), n.default.createElement(t.Icon, {
    as: null != u ? u : de,
    bg: "inherit",
    color: "inherit",
    h: 4,
    w: 4
  }), n.default.createElement(t.Icon, {
    as: o,
    bg: "inherit",
    bottom: 0,
    className: "call-to-action",
    color: "inherit",
    h: 4,
    left: 0,
    m: "auto",
    opacity: 0,
    pos: "absolute",
    right: 0,
    top: 0,
    transition: "all  cubic-bezier(0.4, 1, 0.9, 0.6) 0.3s",
    w: 4
  })));
},
    ve = function ve(r) {
  var i = r.page,
      u = o(r, ["page"]),
      s = e.useContext(le),
      c = s.actions,
      l = s.state,
      f = c.changePage,
      p = l.currentPage,
      h = l.isDisabled,
      d = l.activeStyles,
      g = l.hoverIconLeft,
      v = l.hoverIconRight,
      y = l.separatorStyles,
      m = l.normalStyles,
      _ = l.separatorIcon,
      b = p === i,
      P = i === oe,
      S = i === ie,
      w = b ? "Current page, page " + i : "Go to page " + i,
      I = e.useMemo(function () {
    return {
      minW: "auto",
      px: 1,
      pointerEvents: h ? "none" : "auto",
      cursor: "pointer",
      onClick: function onClick() {
        return f(i);
      }
    };
  }, [h]);
  return P ? n.default.createElement(ge, {
    hoverIcon: null != g ? g : pe,
    isDisabled: h,
    separatorIcon: _,
    separatorPosition: "left",
    separatorStyles: y
  }) : S ? n.default.createElement(ge, {
    hoverIcon: null != v ? v : he,
    isDisabled: h,
    separatorIcon: _,
    separatorPosition: "right",
    separatorStyles: y
  }) : n.default.createElement(t.Flex, {
    as: "li"
  }, n.default.createElement(t.Button, _a({
    "aria-label": w
  }, h ? {
    "aria-disabled": !0
  } : {}, b ? {
    "aria-current": !0
  } : {}, I, u, b ? d : m), i));
};

exports.Container = function (e) {
  var r = e.children,
      i = o(e, ["children"]);
  return n.default.createElement(t.Flex, _a({
    "aria-label": "pagination navigation",
    as: "nav"
  }, i), r);
}, exports.Next = function (r) {
  var i = r.children,
      u = o(r, ["children"]),
      s = e.useContext(le),
      c = s.actions,
      l = s.state,
      f = c.changePage,
      p = l.currentPage,
      h = l.pagesQuantity,
      d = l.isDisabled,
      g = !h || p > h - 1;
  return n.default.createElement(t.Button, _a({
    "aria-label": "Next page",
    isDisabled: g || d,
    onClick: function onClick() {
      g || f(p + 1);
    },
    pointerEvents: d ? "none" : "auto"
  }, g || d ? {
    "aria-disabled": !0
  } : {}, u), i);
}, exports.Page = ve, exports.PageGroup = function (r) {
  var i,
      u,
      s,
      c,
      l,
      f = o(r, []),
      p = (i = e.useContext(le).state, u = i.currentPage, s = i.innerLimit, c = i.outerLimit, l = i.pagesQuantity, {
    pages: e.useMemo(function () {
      return ce({
        currentPage: u,
        innerLimit: s,
        outerLimit: c,
        pagesQuantity: l
      });
    }, [u, s, c, l])
  }).pages;
  return n.default.createElement(t.Stack, _a({
    isInline: !0,
    as: "ol",
    spacing: 1
  }, f), p.map(function (e, t) {
    return n.default.createElement(ve, {
      key: "paginator_page_" + e + "_" + t,
      page: e
    });
  }));
}, exports.Paginator = function (e) {
  var t = e.children,
      r = e.pagesQuantity,
      a = void 0 === r ? ae.pagesQuantity : r,
      o = e.normalStyles,
      i = void 0 === o ? ae.normalStyles : o,
      u = e.activeStyles,
      s = void 0 === u ? ae.activeStyles : u,
      c = e.separatorStyles,
      l = void 0 === c ? ae.separatorStyles : c,
      f = e.isDisabled,
      p = void 0 === f ? ae.isDisabled : f,
      h = e.innerLimit,
      d = void 0 === h ? ae.innerLimit : h,
      g = e.separatorIcon,
      v = void 0 === g ? ae.separatorIcon : g,
      y = e.outerLimit,
      m = void 0 === y ? ae.outerLimit : y,
      _ = e.hoverIconLeft,
      b = void 0 === _ ? ae.hoverIconLeft : _,
      P = e.hoverIconRight,
      S = void 0 === P ? ae.hoverIconRight : P,
      w = e.currentPage,
      I = void 0 === w ? ae.currentPage : w,
      x = e.onPageChange;
  return n.default.createElement(fe, {
    activeStyles: s,
    currentPage: I,
    hoverIconLeft: b,
    hoverIconRight: S,
    innerLimit: d,
    isDisabled: p,
    normalStyles: i,
    onPageChange: x,
    outerLimit: m,
    pagesQuantity: a,
    separatorIcon: v,
    separatorStyles: l
  }, t);
}, exports.Previous = function (r) {
  var i = r.children,
      u = o(r, ["children"]),
      s = e.useContext(le),
      c = s.actions,
      l = s.state,
      f = c.changePage,
      p = l.currentPage,
      h = l.isDisabled,
      d = 1 === p;
  return n.default.createElement(t.Button, _a({
    "aria-label": "Previous page",
    isDisabled: d || h,
    onClick: function onClick() {
      d || f(p - 1);
    },
    pointerEvents: h ? "none" : "auto"
  }, d || h ? {
    "aria-disabled": !0
  } : {}, u), i);
}, exports.generatePages = ce, exports.usePaginator = function (t) {
  var r,
      n,
      a = t.total,
      o = t.initialState,
      u = i(e.useState(null !== (r = o.pageSize) && void 0 !== r ? r : 0), 2),
      s = u[0],
      c = u[1],
      l = i(e.useState(o.currentPage), 2),
      f = l[0],
      p = l[1],
      h = i(e.useState(null !== (n = o.isDisabled) && void 0 !== n && n), 2),
      d = h[0],
      g = h[1],
      v = e.useMemo(function () {
    return s ? f * s - s : 0;
  }, [f, s]),
      y = e.useMemo(function () {
    return a && s ? Math.ceil(a / s) : 0;
  }, [a, s]);
  return {
    offset: v,
    currentPage: f,
    pagesQuantity: y,
    setCurrentPage: p,
    pageSize: s,
    setPageSize: c,
    isDisabled: d,
    setIsDisabled: g
  };
};